import React, { useEffect, useState } from "react";
import { Client } from "../../interfaces/client";
import { formatDate } from "../../services/helpers";
import { getAdditionalFormsHistory } from "../../services/additionalFormService";
import { HistoryAdditionalForm } from "../../interfaces/additionalForm";

interface AdditionalFormsHistoryTableProps {
  client: Client;
}

const AdditionalFormsHistoryTable: React.FC<
  AdditionalFormsHistoryTableProps
> = ({ client }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [additionalForms, setAdditionalForms] = useState<
    HistoryAdditionalForm[]
  >([]);

  useEffect(() => {
    const getHistory = async () => {
      try {
        setLoadingSpinner(true);

        const historyResponse = await getAdditionalFormsHistory(
          client.clientID,
        );

        setAdditionalForms(historyResponse);
      } catch (error) {
        console.error("Error getting additional forms history:", error);
        setErrorMessage("Error getting additional forms history.");
      } finally {
        setLoadingSpinner(false);
      }
    };

    getHistory();
  }, []);

  return (
    <>
      <div className="table-wrapper">
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <div className="table-container" style={{ fontSize: "large" }}>
          <table className="table" style={{ cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "140px" }} title={"Type"}>
                  Type
                </th>
                <th style={{ width: "140px" }} title={"Modified By"}>
                  Modified By
                </th>
                <th style={{ width: "200px" }} title={"Modified At"}>
                  Modified At
                </th>
              </tr>
            </thead>
            <tbody>
              {additionalForms?.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center" }}>
                    No history found.
                  </td>
                </tr>
              ) : (
                additionalForms?.map((row, index) => (
                  <tr key={`${row.additionalFormID}-${index}`}>
                    <td className="ellipsis-cell" title={row.formType ?? ""}>
                      {row.formType}
                    </td>
                    <td className="ellipsis-cell" title={row.modifiedBy ?? ""}>
                      {row.modifiedBy}
                    </td>
                    <td>{formatDate(row.modifiedAt, "datetime")}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {loadingSpinner && (
          <div className="loading-mask">
            <div className="loading-spinner"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdditionalFormsHistoryTable;
